export interface StackDatum {
  key: string;
  year: number;
  value: number;
  color?: string;
  [key: string]: any;
}

export const stack = (data: StackDatum[]) => {
  const float32 = (number: number) => parseFloat(number.toFixed(7));
  const total = data.reduce((sum, d) => sum + d.value, 0);
  let value = 0;

  return data.map((d) => ({
    ...d,
    relativeValue: float32(d.value / total),
    startValue: float32(value / total),
    endValue: float32((value += d.value) / total),
  }));
};
